import React from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { Appointment } from "../../../../services/appointmentService";
import AppointmentDetailPanel, { AppointmentDetailPanelProps } from "./AppointmentDetailPanel";

type AppointmentDetailOffcanvasProps = Omit<AppointmentDetailPanelProps, "onClose"> & {
  isOpen: boolean;
  appointment: Appointment | null;
  onClose: () => void;
};

const AppointmentDetailOffcanvas = ({
  isOpen,
  appointment,
  onClose,
  ...panelProps
}: AppointmentDetailOffcanvasProps) => (
  <Offcanvas isOpen={isOpen} toggle={onClose} direction="end" className="agenda-detail-offcanvas border-0">
    <OffcanvasHeader toggle={onClose} />
    <OffcanvasBody className="pt-0">
      <AppointmentDetailPanel
        variant="embedded"
        appointment={appointment}
        onClose={onClose}
        {...panelProps}
      />
    </OffcanvasBody>
  </Offcanvas>
);

export default AppointmentDetailOffcanvas;
